import { Stack, Typography, SxProps, Box } from '@mui/material';
import { subtitleSX, titleSX } from '@/components/blocks/DpLibrary/DpTitlesDistribuidor/style/main';
import { useIsMobile } from '@/data/hooks/useIsMobile';
import React from 'react';

export const DpTitlesDistribuidor = ({
	title,
	subtitle,
	children,
	...props
}: {
	title: string;
	subtitle?: string;
	sx?: SxProps;
	children?: React.ReactNode;
}) => {
	const isMobile = useIsMobile();

	return isMobile ? (
		<React.Fragment>
			<Box alignItems={'center'} {...props} sx={{ px: '15px', pt: '22px' }}>
				{title ? (
					<Typography component="h1" sx={titleSX}>
						{' '}
						{title}{' '}
					</Typography>
				) : null}
			</Box>
			<Box sx={{ px: '33px' }}>
				{subtitle || children ? (
					<Typography component={'h2'} sx={subtitleSX}>
						{' '}
						{subtitle || children}{' '}
					</Typography>
				) : null}
			</Box>
		</React.Fragment>
	) : (
		<Stack alignItems={'center'} {...props}>
			{title ? (
				<Typography component="h1" sx={titleSX}>
					{' '}
					{title}{' '}
				</Typography>
			) : null}
			{subtitle || children ? (
				<Typography component={'h2'} sx={subtitleSX}>
					{' '}
					{subtitle || children}{' '}
				</Typography>
			) : null}
		</Stack>
	);
};
